<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
    <section class="container admin-dashboard-parent copy-editor-container">
        <section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Suggested Next Steps'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
                <h1>Suggested Next Steps</h1>
                <input type="submit" value="Add New" (click)="addNew()">
			</div>
		</section>
        <div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>
        <section class="all-users-data">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-borderless table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Title</th>
                            <th scope="col">Logo</th>
                            <th scope="col">Call to Action</th>
                        </tr>
                    </thead>
                    <tbody cdkDropList (cdkDropListDropped)="onDrop($event)">
                        <ng-container *ngFor="let item of list; let i = index;">
                            <tr class="body-header" (click)="toggleSection(i)"
                                                    cdkDrag >
                              <td class="col-md">{{item.title}}</td>
                              <td class="col-md">{{item.image}}</td>
                              <td class="col-md">{{item.buttonCopy}}</td>
                            </tr>
                            <tr class="body-body" [ngClass]="{'hide':!lineState[i],'expanded':lineState[i]}">
                                <td colspan="4">
                                    <label>
                                        <span class="label">Title:</span>
                                        <input type="text" [(ngModel)]="list[i].title">
                                    </label><br>
                                    <label>
                                        <span class="label">Copy:</span>
                                        <input type="text" [(ngModel)]="list[i].copy">
                                    </label><br>
                                    <label>
                                        <span class="label">Image:</span>
                                        <input type="text" [(ngModel)]="list[i].image">
                                    </label><br>
                                    <label>
                                        <span class="label">Rule:</span>
                                        <input type="text" [(ngModel)]="list[i].rule">
                                    </label><br>
                                    <label>
                                        <span class="label">ButtonCopy:</span>
                                        <input type="text" [(ngModel)]="list[i].buttonCopy">
                                    </label><br>
                                    <label>
                                        <span class="label">ButtonLink:</span>
                                        <input type="text" [(ngModel)]="list[i].buttonLink">
                                    </label><br>
                                    <!-- <label><span class="label">Action:</span><input type="text" [(ngModel)]="list[i].Action"></label><br> -->
                                    <!-- <label><span class="label">DropDown:</span><input type="text" [(ngModel)]="list[i].Dropdown"></label><br> -->
                                    <input type="submit" value="Save" (click)="saveItem(i)">
                                    <input type="button" value="Delete" (click)="deleteItem(i)">
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </section>
    </section>
</section>
